/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 * Types for page ExpensesAnalyzer
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.1.0
 */

import { EExpensesAnalyzerField } from '../components/ExpensesAnalyzerTable/types/expensesAnalyzerTableTypes';

export enum EExpensesAnalyzerTypes {
    Account = 'Account',
    AccountSubscribers = 'AccountSubscribers',
    AccountSingle = 'AccountSingle',
    AccountSingleSubscribers = 'AccountSingleSubscribers',
    BillsAccount = 'BillsAccount',
    BillsAccountSingle = 'BillAccountSingle',
    BillsAccountsSubscribers = 'BillsAccountsSubscribers',
    BillsAccountSingleSubscribers = 'BillsAccountSingleSubscribers',
    BillsUnpaidAccount = 'BillsUnpaidAccount',
    BillsUnpaidAccountSingle = 'BillUnpaidAccountSingle',
    BillsUnpaidAccountsSubscribers = 'BillsUnpaidAccountsSubscribers',
    BillsUnpaidAccountSingleSubscribers = 'BillsUnpaidAccountSingleSubscribers',
    SubscriberFixed = 'SubscriberFixed',
    SubscriberFixedSingle = 'SubscriberFixedSingle',
    SubscriberMobile = 'SubscriberMobile',
    SubscriberMobileSingle = 'SubscriberMobileSingle',
}

export interface IExpensesAnalyzerMeta {
    chartIdField: TChartIdField;
    isBillsType?: boolean;
    isDynamicDisabled?: boolean;
    isTableAccount?: boolean;
}

export type TChartIdField = EExpensesAnalyzerField.ACCOUNT | EExpensesAnalyzerField.MSISDN;

export enum EChartLabelType {
    fio = 'fio',
    region = 'region'
}

export interface IExpensesAccountsListItem {
    account: string;
    clntId: number;
}
